module.exports = __webpack_public_path__ + "static/media/speech_09.0c5b8dfc.svg";